import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import api from "../lib/api";

const seen = new Set();
const track = (id, type) => {
  if (type === "view") { if (seen.has(id)) return; seen.add(id); }
  api.post(`/banners/${id}/event`, { type }).catch(() => {});
};

const Wrap = ({ b, children, className, testid }) => {
  useEffect(() => { track(b.id, "view"); }, [b.id]);
  const onClick = () => track(b.id, "click");
  return b.link
    ? <a href={b.link} target="_blank" rel="noreferrer sponsored" onClick={onClick} data-testid={testid} className={className}>{children}</a>
    : <div data-testid={testid} className={className}>{children}</div>;
};

export function BannerCarousel({ compact = false }) {
  const [items, setItems] = useState([]);
  const [i, setI] = useState(0);
  useEffect(() => { api.get("/banners/public?placement=hero").then((r) => setItems(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    if (items.length < 2) return;
    const t = setInterval(() => setI((n) => (n + 1) % items.length), 5000);
    return () => clearInterval(t);
  }, [items.length]);
  if (!items.length) return null;
  const b = items[i];
  return (
    <section data-testid="sponsored-carousel" className={`max-w-7xl mx-auto px-4 sm:px-8 ${compact ? "pb-6" : "pb-14"}`}>
      {!compact && <p className="nb-label mb-3" style={{ letterSpacing: "0.2em" }}>Sponsored</p>}
      <div className="relative nb overflow-hidden" style={{ borderRadius: 18 }}>
        <Wrap b={b} testid={`banner-hero-${b.id}`} className="block">
          <picture>
            {b.image_url_mobile && <source media="(max-width: 767px)" srcSet={b.image_url_mobile} />}
            <img src={b.image_url} alt={b.title || "Sponsored banner"} className={`w-full object-cover ${compact ? "h-44" : "h-44 sm:h-64 md:h-80"}`} />
          </picture>
          {b.title && <p className="absolute bottom-3 left-3 nb-badge bg-white" style={{ padding: "6px 14px" }}>{b.title}</p>}
        </Wrap>
        {items.length > 1 && (
          <>
            <button data-testid="banner-prev" onClick={() => setI((i - 1 + items.length) % items.length)}
              className="absolute left-3 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full border-2 border-[#171B33] bg-white flex items-center justify-center hover:bg-lime-300 transition-colors"><ChevronLeft className="w-4 h-4" /></button>
            <button data-testid="banner-next" onClick={() => setI((i + 1) % items.length)}
              className="absolute right-3 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full border-2 border-[#171B33] bg-white flex items-center justify-center hover:bg-lime-300 transition-colors"><ChevronRight className="w-4 h-4" /></button>
            <div className="absolute bottom-3 right-3 flex gap-1.5">
              {items.map((it, n) => <span key={it.id} className="w-2.5 h-2.5 rounded-full border-2 border-[#171B33]" style={{ background: n === i ? "#A3E635" : "#fff" }} />)}
            </div>
          </>
        )}
      </div>
    </section>
  );
}

export function BannerStrip() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/banners/public?placement=strip").then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <section data-testid="sponsored-strip" className="max-w-7xl mx-auto px-4 sm:px-8 py-10 space-y-4">
      {items.map((b) => (
        <Wrap key={b.id} b={b} testid={`banner-strip-${b.id}`} className="block nb overflow-hidden" >
          <picture>
            {b.image_url_mobile && <source media="(max-width: 767px)" srcSet={b.image_url_mobile} />}
            <img src={b.image_url} alt={b.title || "Sponsored"} className="w-full h-24 sm:h-32 object-cover" />
          </picture>
        </Wrap>
      ))}
    </section>
  );
}
